import { z } from 'zod'

import { AutoAssignmentType } from 'common/settings/constants/AutoAssignmentType'
import { PauseAutomationFormat } from 'common/settings/constants/PauseAutomationFormat'

export const LiveChatAccountSettingsSchema = z.object({
  pause_automation_format: z.enum(PauseAutomationFormat).optional(),
  assign_on_previous_agent_when_reopen: z.boolean(),
  auto_assign_type: z.enum(AutoAssignmentType).nullable(),
})

export enum LiveChatAccountSettings {
  ASSIGN_ON_PREVIOUS_AGENT_WHEN_OPEN = 'assign_on_previous_agent_when_reopen',
  AUTO_ASSIGN_TYPE = 'auto_assign_type',
  PAUSE_AUTOMATION_FORMAT = 'pause_automation_format',
}

export const LiveChatAccountSettingsRequestSchema = z.discriminatedUnion('settings_key', [
  z.object({
    settings_key: z.literal(LiveChatAccountSettings.ASSIGN_ON_PREVIOUS_AGENT_WHEN_OPEN),
    value: z.boolean(),
  }),
  z.object({
    settings_key: z.literal(LiveChatAccountSettings.AUTO_ASSIGN_TYPE),
    value: z.enum(AutoAssignmentType).nullable(),
  }),
  z.object({
    settings_key: z.literal(LiveChatAccountSettings.PAUSE_AUTOMATION_FORMAT),
    value: z.enum(PauseAutomationFormat).optional(),
  }),
])
